import { TimeSlotStructure, TimeSlotStructureType, TimeSlotType } from "../../model/TimeSlotStructure";
import { ApiResponse } from "../CustomFetch";
import { api } from "./BaseApi";

const timeSlotStructureApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTimeSlotStructure: builder.query<TimeSlotStructure, void>({
      query: () => "/TimeSlot",
      transformResponse: (response: ApiResponse<TimeSlotStructure>) => {
        setExamTimeSlotIndexes(response.data);
        return response.data;
      },
    }),
  }),
});

export const { useGetTimeSlotStructureQuery } = timeSlotStructureApi;

const setExamTimeSlotIndexes = (timeSlotStructure: TimeSlotStructure): void => {
  Object.keys(timeSlotStructure).forEach((key) => {
    timeSlotStructure[key as TimeSlotStructureType]
      .filter((timeSlot) => timeSlot.type === undefined || timeSlot.type === TimeSlotType.Exam)
      .forEach((timeSlot, index) => (timeSlot.index = index + 1)); // Exam time slot index in DB starts with 1.
  });
};
